export const spielerpaesseBeantragenPassstelle2026 = {
  "id": "spielerpaesse-beantragen-passstelle-2026",
  "title": "Spielerpässe beantragen – (k)ein Buch mit sieben Siegeln",
  "slug": "spielerpaesse-beantragen-passstelle-2026",
  "publishedAt": "2026-07-27T09:00:00Z",
  "author": "Sven Neubert",
  "language": "de",
  "readTime": "4 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "Passstelle",
    "Spielerpässe",
    "Vereinswechsel",
    "Clubee",
    "Transfers"
  ],
  "excerpt": "In der Passstelle für die 1. und 2. Rugby-Bundesliga ist in diesen Tagen Hochsaison: die Zeit der Vereinswechsel ist angebrochen und auch die Verlängerungen der Spielerpässe stehen an. Was es dabei zu beachten gilt, erklärt die Passstelle in diesem Überblick.",
  "img": "/images/spielerpaesse-beantragen-passstelle-2026.jpeg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "In der Passstelle für die 1. und 2. Rugby-Bundesliga ist in diesen Tagen Hochsaison: die Zeit der Vereinswechsel ist angebrochen und auch die Verlängerungen der Spielerpässe stehen an."
    },
    {
      "type": "paragraph",
      "content": "Was in der Vergangenheit mit viel Papier verbunden war, läuft heutzutage, zumindest in den Rugby-Bundesligen, über die Clubee-Plattform weitestgehend online. Pässe können jederzeit verlängert werden, ebenso können die Vereine jederzeit neue Spielerpässe beantragen. Hier gibt es ein gutes Video, wie das mit dem Anlegen eines neuen Spielerpasses funktioniert:"
    },
    {
      "type": "list",
      "items": [
        { "content": "Video: Einen neuen Spielerpass anlegen (YouTube)", "url": "https://youtu.be/hEJrlMiaTGs?si=Qj_NDES_uqQi-boE" }
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Aber natürlich gibt es einige Dinge zu beachten:"
    },
    {
      "type": "paragraph",
      "content": "Ein Vereinswechsel ist generell nur in der Zeit vom 15. bis 31. Juli und für die 2. Bundesliga zusätzlich vom 2. bis 10. Januar möglich. Außerhalb dieser Zeiten darf ein Spieler nur dann den Verein wechseln, wenn sich sein Arbeitsplatz, sein Studienplatz oder sein Hauptwohnsitz ändert, im Gebiet eines anderen Landesverbandes liegt und mindestens 120 km von seinem bisherigen Verein entfernt ist. In diesem Fall unterliegt der Spieler dann allerdings einer sechswöchigen Sperre, in der er vom neuen Verein nicht eingesetzt werden darf."
    },
    {
      "type": "paragraph",
      "content": "Wenn ein Spieler den Verein wechseln möchte, muß er dies dem abgebenden Verein, der Passstelle von Rugby Deutschland sowie dem neuen Verein schriftlich (email genügt heutzutage) durch eine sogenannte Wechselerklärung mitteilen. In der Spielordnung findet sich dazu in mehreren Paragrafen noch die Formulierungen „schriftlich“ und „eigenhändig unterschrieben“. Dazu wird ein entsprechender Änderungsantrag der Spielordnung zum nächsten DRT eingereicht werden. Die bisher geltende Ordnung findet man hier:"
    },
    {
      "type": "list",
      "items": [
        { "content": "Ordnungen von Rugby Deutschland", "url": "https://www.rugbydeutschland.org/rugby-deutschland-88444v4" }
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Der neue Verein muß den Transfer über Clubee einleiten (und dabei die entsprechenden Nachweise wie die Freigabe/Clearance hochladen) und der abgebende Verein dann über Clubee zustimmen. Dazu versendet das System automatisch eine email, in der dazu aufgefordert wird. Der Name des Spielers muß bei diesem Vorgang identisch sein mit dem, wie er beim alten Verein angelegt war, sonst findet das System den Spieler nicht."
    },
    {
      "type": "paragraph",
      "content": "Und wenn alles ok ist, gibt die Passstelle den Transfer frei. Das passiert in der Regel zeitnah, doch sollte man immer eine gewisse Zeit einplanen, denn wir arbeiten alle im Ehrenamt. Wie der Transfer mit Clubee funktioniert, wird hier ganz gut erklärt:"
    },
    {
      "type": "list",
      "items": [
        { "content": "Anleitung: Transfer mit Clubee (Guidde)", "url": "https://app.guidde.com/share/playbooks/pmmyYWzEYNixeZuXnuPWmi?origin=tk1W9w9Uo9ReucUHZniiHU5iyq92" }
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Manchmal möchte ein Spieler sich verändern und sich von seinem bisherigen Verein trennen, ohne schon zu wissen, wo er in Zukunft spielen will. In diesem Fall ist es ratsam, den Verein um eine sogenannte Freistellung zu bitten und dies dann auch der Passstelle mitzuteilen. Darauf wird dann im Spielerpass ein entsprechender Vermerk gemacht. Eine Wechselerklärung wird damit überflüssig, für einen eventuellen zukünftigen Neustart bei einem anderen Verein muß dann lediglich ein neuer Spielerpass beantragt werden, was dann auch über die Transfer-Funktion möglich ist."
    },
    {
      "type": "paragraph",
      "content": "Passverlängerungen in Clubee sind wirklich ein Kinderspiel. Es gilt aber zu bedenken, daß sich die Passstelle auch bei Verlängerungen bzw. Freigaben der Pässe eines kompletten Teams jeden einzelnen Spielerpass ansehen muß – und das dauert einfach. Deshalb sollte man mit den Verlängerungen nicht bis zum letzten Moment warten."
    },
    {
      "type": "paragraph",
      "content": "Eine Besonderheit gilt für Spieler, die aus dem Ausland zu einem deutschen Club wechseln wollen: hier ist eine sogenannte „Clearance“ des ausländischen Verbandes notwendig, die durch das Büro von Rugby Deutschland bestätigt werden muß und dann mit dem Antrag auf einen Spielerpass bei Clubee mit hochgeladen werden muß. Erfahrungsgemäß kann das mit der Clearance aus dem Ausland etwas dauern, und ohne Clearance kann die Passstelle den entsprechenden Spielerpass nicht freigeben."
    },
    {
      "type": "paragraph",
      "content": "Auf der Webpage von Rugby Deutschland findet sich zum Thema Clubee eine umfangreiche Linksammlung, und im Youtube-Kanal von Rugby Deutschland finden sich auch noch jede Menge Clips zum Thema Clubee, einfach mal reinklicken:"
    },
    {
      "type": "list",
      "items": [
        { "content": "Linksammlung zum Thema Clubee", "url": "https://www.rugbydeutschland.org/clubee-268567v4" },
        { "content": "Youtube-Kanal von Rugby Deutschland", "url": "https://www.youtube.com/@RugbyDeutschland/videos" }
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Die Bundesliga-Passstelle beschäftigt sich generell nicht mit Jugend- oder Regionalligapässen und auch nicht mit den Spielerpässen der Frauen, das ist Aufgabe der Landesverbände bzw. der Rugby-Frauen."
    },
    {
      "type": "paragraph",
      "content": "Falls irgendwelche Probleme mit Spielerpässen auftauchen sollten, ist die Passstelle per email an passstelle(AT)rugbydeutschland.org jederzeit (fast jederzeit…) zu erreichen."
    }
  ]
};
